import Head from 'next/head';

import PricingTable from '../../components/pricing/PricingTable';
import { TooltipProvider } from '../../components/tailwind-ui';

export default function IndexPage() {
  return (
    <>
      <Head>
        <title>NMRium - Pricing</title>
      </Head>
      <TooltipProvider>
        <PricingTable />
      </TooltipProvider>
    </>
  );
}
